import React from "react";
import AppRow from "src/commun/composants/grille/AppRow";
// @ts-ignore
import imgLogo from "src/img/logo_FER_f.png";
import styles from "./AppFooter.scss";
import AppCol from "src/commun/composants/grille/AppCol";
import { useAppState } from "src/app/state/StateProvider";
import { useAppText } from "src/commun/composants/AppText";
import { Stack } from "react-bootstrap";

const AppFooter = () => {
  const [{ configuration, langue }] = useAppState();
  const { tString } = useAppText();

  const getLibelleTextMilieu = () => {
    switch (langue) {
      case "fr": {
        return configuration.footerTextMilieuFr;
      }
      case "en": {
        return configuration.footerTextMilieuEn;
      }
      case "de": {
        return configuration.footerTextMilieuDe;
      }
      default : {
        return configuration.footerTextMilieuFr;
      }
    }
  };

  return (


    <div className={styles.piedDePage}>
      <AppRow className={`${styles.piedDePageRow}`}>
        <AppCol md="auto">
          {configuration?.displayLogoFer ? <img className={`${styles.section} ${styles.logoStyle}`} alt="" src={imgLogo} height={"40px"} /> : <div className={styles.hiddenLogo} />}
        </AppCol>
        <AppCol md className={`${styles.section} align-middle`}>
          <span className={styles.textFer}>{getLibelleTextMilieu()}</span>
        </AppCol>
        <AppCol md="auto" className={styles.section}>
          <Stack direction="horizontal" gap={4}>
            {configuration?.footerConditionsGeneralesUrl ? <a className={`${styles.link} ms-auto`} href={configuration?.footerConditionsGeneralesUrl} rel="noopener noreferrer" target="_blank">{tString("footer.conditionsgenerales.libelle")}</a> : <span className={`${styles.link} ms-auto`}/>}
            {configuration?.footerFaqUrl ? <a className={styles.link} href={configuration?.footerFaqUrl} rel="noopener noreferrer" target="_blank">{tString("footer.faq.libelle")}</a> : <span className={`${styles.link}`}/>}
            {configuration?.footerContactUrl ? <a className={`${styles.link} ${styles.footerEnd} me-auto`} href={configuration?.footerContactUrl} rel="noopener noreferrer" target="_blank">{tString("footer.contact.libelle")}</a> : <span className={`${styles.link} me-auto`}/>}
          </Stack>
        </AppCol>
      </AppRow>
    </div>
  );
};

export default AppFooter;
